module.exports = [{
      plugin: require('/zeit/4f598cc5/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
